var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_344_47503)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3103 5.25415L18.1216 1.06446C17.9823 0.925137 17.8169 0.814617 17.6349 0.739213C17.4529 0.66381 17.2578 0.625 17.0608 0.625C16.8638 0.625 16.6687 0.66381 16.4867 0.739213C16.3047 0.814617 16.1393 0.925137 16 1.06446L4.43969 12.6257C4.2998 12.7645 4.18889 12.9297 4.11341 13.1117C4.03792 13.2938 3.99938 13.489 4.00001 13.686V17.8757C4.00001 18.2735 4.15804 18.6551 4.43935 18.9364C4.72065 19.2177 5.10218 19.3757 5.50001 19.3757H9.6897C9.88675 19.3763 10.082 19.3378 10.264 19.2623C10.446 19.1868 10.6112 19.0759 10.75 18.936L22.3103 7.37571C22.4496 7.23642 22.5602 7.07104 22.6356 6.88903C22.711 6.70702 22.7498 6.51194 22.7498 6.31493C22.7498 6.11792 22.711 5.92284 22.6356 5.74082C22.5602 5.55881 22.4496 5.39344 22.3103 5.25415ZM9.6897 17.8757H5.50001V13.686L13.75 5.43602L17.9397 9.62571L9.6897 17.8757ZM19 8.56446L14.8103 4.37571L17.0603 2.12571L21.25 6.31446L19 8.56446Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_344_47503",
    x: 0,
    y: 0.625,
    width: 26.75,
    height: 26.751,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_344_47503"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_344_47503",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.5f0144f4bfde38bc3ef0cac3b63a182d.svg";
export { ForwardRef as ReactComponent };